export class TraceabilityCategory {
  primary: 'PSF' | 'PFC+' | 'MATER'

  secondary: 'PSF' | 'PFC+' | 'MATER' | 'INGREDIENT' | 'PACKAGING'

  /** Order of display */
  order: number

  constructor(category: TraceabilityCategory) {
    this.primary = category.primary || 'MATER'
    this.secondary = category.secondary
    this.order = this.getCategoryOrder(this.primary)
  }

  private getCategoryOrder(categoryName: string): number {
    let order: number
    switch (categoryName) {
      case 'PFC+':
        order = 2
        break
      case 'PSF':
        order = 1
        break
      case 'MATER':
      case 'INGREDIENT':
      case 'PACKAGING':
      default:
        order = 0
        break
    }
    return order
  }
}
